import { makeApiCall } from "../apiRequest";

export default {
  state: {
    templateReport: [],
    taskReport: [],
    ticketReport: [],
    complianceReport: [],
    taskEfficiencyReport: [],
    maintenanceReport: [],
    staffPerformanceReport: [],
    roomBedReport: null,
  },
  getters: {
    getTemplateReport: (state) => state.templateReport,
    getTaskReport: (state) => state.taskReport,
    getTicketReport: (state) => state.ticketReport,
    getComplianceReport: (state) => state.complianceReport,
    getTaskEfficiencyReport: (state) => state.taskEfficiencyReport,
    getMaintenanceReport: (state) => state.maintenanceReport,
    getStaffPerformanceReport: (state) => state.staffPerformanceReport,
    getRoomBedReport: (state) => state.roomBedReport,
  },
  actions: {
    async getTemplateReport({ commit }, payload) {
      const response = await makeApiCall(
        `Reporting/getTemplateReport`,
        "POST",
        payload
      );
      if (response && !response.error && response.status === 200) {
        commit("setTemplateReport", response.data?.data ?? []);
      }
      return response;
    },
    async getTaskReport({ commit }, payload) {
      const response = await makeApiCall(
        `Reporting/getTaskReport`,
        "POST",
        payload
      );
      if (response && !response.error && response.status === 200) {
        commit("setTaskReport", response.data?.data ?? []);
      }
      return response;
    },
    async getTicketReport({ commit }, payload) {
      const response = await makeApiCall(
        `Reporting/getTicketReport`,
        "POST",
        payload
      );
      if (response && !response.error && response.status === 200) {
        commit("setTicketReport", response.data?.data ?? []);
      }
      return response;
    },
    async getComplianceReport({ commit }, payload) {
      const response = await makeApiCall(
        `Reporting/getComplianceReport`,
        "POST",
        payload
      );
      if (response && !response.error && response.status === 200) {
        commit("setComplianceReport", response.data?.data ?? []);
      }
      return response;
    },
    async getTaskEfficiencyReport({ commit }, payload) {
      const response = await makeApiCall(
        `Reporting/getTaskEfficiencyReport`,
        "POST",
        payload
      );
      if (response && !response.error && response.status === 200) {
        commit("setTaskEfficiencyReport", response.data?.data ?? []);
      }
      return response;
    },
    async getMaintenanceReport({ commit }, payload) {
      const response = await makeApiCall(
        `Reporting/getMaintenanceReport`,
        "POST",
        payload
      );
      if (response && !response.error && response.status === 200) {
        commit("setMaintenanceReport", response.data?.data ?? []);
      }
      return response;
    },
    async getStaffPerformanceReport({ commit }, payload) {
      const response = await makeApiCall(
        `Reporting/getStaffPerformanceReport`,
        "POST",
        payload
      );
      if (response && !response.error && response.status === 200) {
        commit("setStaffPerformanceReport", response.data?.data ?? []);
      }
      return response;
    },
    async getRoomBedReport({ commit }, payload) {
      const response = await makeApiCall(
        `Reporting/getRoomBedReport`,
        "POST",
        payload
      );
      if (
        response &&
        !response.error &&
        response.status === 200 &&
        response.data &&
        response.data.succeeded
      ) {
        commit("setRoomBedReport", response.data.data ?? null);
      } else {
        commit("setRoomBedReport", null);
      }
      return response;
    },
  },
  mutations: {
    setTemplateReport(state, payload) {
      state.templateReport = payload;
    },
    setTaskReport(state, payload) {
      state.taskReport = payload;
    },
    setTicketReport(state, payload) {
      state.ticketReport = payload;
    },
    setComplianceReport(state, payload) {
      state.complianceReport = payload;
    },
    setTaskEfficiencyReport(state, payload) {
      state.taskEfficiencyReport = payload;
    },
    setMaintenanceReport(state, payload) {
      state.maintenanceReport = payload;
    },
    setStaffPerformanceReport(state, payload) {
      state.staffPerformanceReport = payload;
    },
    setRoomBedReport(state, payload) {
      state.roomBedReport = payload;
    },
  },
};
